var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('section',[_c('aside',{ref:"element",staticClass:"sidebar",class:{ secondStack: _vm.isSecondstack },style:(_vm.style)},[_vm._t("default")],2),(_vm.isOverlayEnable)?_c('div',{ref:"overlay",staticClass:"overlay"}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }